<script setup>
import { Dialog as HeadlessDialog, TransitionRoot } from "@headlessui/vue";

defineOptions({ inheritAttrs: false });

defineProps(["show"]);
</script>

<template>
  <TransitionRoot as="template" :show="show">
    <HeadlessDialog as="div" class="relative z-50" :open="show" v-bind="$attrs">
      <slot />
    </HeadlessDialog>
  </TransitionRoot>
</template>
